export const OfferPrivateTypeOptions = [
    { value: 0, label: "Sharing" },
    { value: 1, label: "Private" }
]
export enum OfferPrivateType {
    Sharing, Private
}